const metaData = (state = {}, action) => {
  switch (action.type) {
    case 'RECEIVE_META_DATA':
      return {
        ...state,
        [action.appname]: action.data,
      };

    default:
      return state;
  }
};

export default metaData;
